import * as types from './types'
import { apiUsers } from '../../api'
import DOMAIN_INFO from 'constants/allowed-domains'

export const startFetchListsRequest = () => ({ type: types.FETCH_LISTS_REQUEST })
export const fetchListsSuccess = (lists) => ({ type: types.FETCH_LISTS_SUCCESS, lists })
export const fetchListsFailure = (error) => ({ type: types.FETCH_LISTS_FAILURE, error })
export const fetchUsersListsSuccess = (lists) => ({ type: types.FETCH_USERS_LISTS_SUCCESS, lists })
export const fetchUsersListsFailure = (error) => ({ type: types.FETCH_USERS_LISTS_FAILURE, error })

export const fetchLists = () => (dispatch, getState) => {
  if (DOMAIN_INFO.isOP) return null

  dispatch(startFetchListsRequest())

  const {
    user: { company, brands },
  } = getState()
  let queryParams = {}
  if (company) {
    queryParams.companies = company
  } else {
    console.error('At least one company id is required.')
    return
  }
  if (brands.length) {
    queryParams.brands = brands.map((brand) => brand.id).join(',')
    queryParams.delegations = brands.reduce((current, next) => current.concat(next.delegations), []).join(',')
  }

  return apiUsers
    .byLists(queryParams)
    .then(({ data, status }) => {
      if (status === 200) {
        const { results } = data
        dispatch(fetchListsSuccess(results))
      } else if (status === 204) {
        dispatch(fetchListsSuccess([]))
        dispatch(fetchUsersListsSuccess([]))
      } else {
        dispatch(fetchListsFailure({ status: data.statusOk, message: data.error }))
        dispatch(fetchUsersListsFailure({ status: data.statusOk, message: data.error }))
      }
    })
    .catch((error) => dispatch(fetchListsFailure(error)))
}
